import React from "react";
import LoaderBackdrop from "../custom-loader-backdrop";

const LoadingWrapper = props => {
  return props.loading ? <LoaderBackdrop /> : props.component
};

export default LoadingWrapper;
